import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { deleteOrg, deleteUser, settingTrue } from '../../../redux/actions';
import defaultLogo from '../../../images/Profile_avatar.png';
import './TopHeader.css';
import { useLocation } from "react-router-dom";

interface TopHeaderProps {
  organizationName: string;
  onMobileMenuToggle: () => void;
  // setShowSettingsModal:any
}

const TopHeader: React.FC<TopHeaderProps> = ({ organizationName, onMobileMenuToggle }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const reduxState = useSelector((state: any) => state);
  const reduxOrg = useSelector((state: any) => state.org);
  const reduxUser = useSelector((state: any) => state.signin);
  const path = useLocation().pathname.replace("/", "");

  const logged = reduxState.signin?.type || 'loggedOut';
  const orgID = reduxOrg?._id;
  console.log(path.includes('nonprofit') ? 'True' : 'False' , 'path')

  // Determine avatar image source
  const avatarSrc = logged === 'individual'
    ? reduxUser.profileImg
    : reduxOrg.images?.logo;

    const dashboardTitle = `Welcome, ${organizationName}!`

  const logout = () => {
    dispatch(deleteUser());
    dispatch(deleteOrg());
    history.push('/');
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header className="top-header">
      <div className="header-content">
        {/* Mobile menu button */}
        <button 
          className="mobile-menu-btn mobile-only"
          onClick={onMobileMenuToggle}
          aria-label="Open menu"
        >
          <span className="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        {/* Welcome message */}
        <div className="welcome-section">
          <h1 className="welcome-title">
            {path === 'dashboard' ? dashboardTitle :
            path === 'connect-payments' ? "Connect Payments" :
            path === 'manage-pay' ? "Manage Donations" :
            path === 'neddie-integration' ? "NEDDIE Integration" :
            path === 'manage-wishlist' ? "Manage Wishlist" :
            path === 'manage-store' ? "Manage Store" : 
            path === 'settings' ? "Settings" :
            path === 'help' ? "Help" : ""
            }
            
          </h1>
        </div>

        {/* User menu */}
        <div className="user-menu">
          <div className="user-menu-container">
            <button 
              className="user-menu-btn"
              onClick={toggleDropdown}
              aria-label="User menu"
            >
              <div className="user-avatar">
                <img
                  src={avatarSrc || defaultLogo}
                  alt="User Avatar"
                  className="avatar-icon"
                />
              </div>
              <span className="menu-text desktop-only">Menu</span>
              <span className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`}>▼</span>
            </button>

            {/* Dropdown menu */}
            {dropdownOpen && (
              <div className="user-dropdown">
                <div className="dropdown-content">
                  {logged === 'nonprofit' && (
                    <>
                         <button
                        className="dropdown-item"
                        onClick={() => {
                          history.push(`/`);
                          setDropdownOpen(false);
                        }}
                        // onClick={() => {
                        //   history.push(`/nonprofit/${orgID}`);
                        //   setDropdownOpen(false);
                        // }}
                      >
                       NEDDIE
                      </button>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          history.push(`/nonprofit/${orgID}`);
                          setDropdownOpen(false);
                        }}
                      >
                        Public Profile
                      </button>

                      <button
                        className="dropdown-item"
                        onClick={() => {
                          window.open('https://www.neddieblog.com/grant-central-search', '_blank');
                          setDropdownOpen(false);
                        }}
                      >
                        Search For Grants
                      </button>

                      {/* <button
                        className="dropdown-item"
                        onClick={() => {
                          window.open('https://www.neddieblog.com/neddie-forum', '_blank');
                          setDropdownOpen(false);
                        }}
                      >
                        Community Forum
                      </button> */}
                    </>
                  )}

                  {logged === 'individual' && (

                    <>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          // history.push('/dashboard/settings');
                          dispatch(settingTrue(true));
                          // setShowSettingsModal(true)
                          setDropdownOpen(false);
                        }}
                      >
                        Settings
                      </button>
                    </>
                  )}

                  {logged === 'nonprofit' && (
                    <>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          history.push('/settings');
                          // dispatch(settingTrue(true));
                          // setShowSettingsModal(true)
                          setDropdownOpen(false);
                        }}
                      >
                        Settings
                      </button>
                    </>
                  )}

                  
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      logout();
                      setDropdownOpen(false);
                    }}
                  >
                    Log Out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Dropdown overlay for mobile */}
      {dropdownOpen && (
        <div 
          className="dropdown-overlay"
          onClick={() => setDropdownOpen(false)}
        />
      )}
    </header>
  );
};

export default TopHeader;